import { Pipe, PipeTransform } from "@angular/core";
import { Permissions } from "src/app/core/common";
import { UserPermissionService } from "src/app/core/services/user-permission-service";

@Pipe({
    name: 'hasPermission',
    standalone: true
})
export class PermissionsPipe implements PipeTransform {
    constructor (private userPermissionService: UserPermissionService) {}

    transform(value: Permissions[]): boolean {
        return this.userPermissionService.isHasPermission(value)
    }
}